import Button from 'components/base/Button';
import Modal from 'components/base/Modal';
import UI from 'stores/ui';
import APIManager from './APIManager';
import './style.scss';

/**
 * 仅本地开发和测试环境显示入口
 */
const Environment: React.FC =
    (__DEV__ && !UI.isTiger) || __LOCAL_DEV__
        ? () => {
              const showAPIManagerModal = () => {
                  Modal.open({
                      className: 'environment-modal',
                      component: APIManager,
                      animation: 'drawer'
                  }).result.catch(() => {});
              };

              return (
                  <Button type="link" size="sm" className="align-baseline" onClick={showAPIManagerModal}>
                      切换测试环境
                  </Button>
              );
          }
        : () => null;

export default Environment;
